import { render, staticRenderFns } from "./OP_Summary.vue?vue&type=template&id=570bc3b7&scoped=true&"
import script from "./OP_Summary.vue?vue&type=script&lang=js&"
export * from "./OP_Summary.vue?vue&type=script&lang=js&"
import style0 from "./OP_Summary.vue?vue&type=style&index=0&id=570bc3b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570bc3b7",
  null
  
)

export default component.exports